import { Enums } from '@bode-canada/core';

const { BuildingTypeEnum, BuildingClassEnum } = Enums;

export const ComparableBuildingTypeMap = {
  [BuildingTypeEnum.HOUSE]: BuildingClassEnum.DETACHED,
  [BuildingTypeEnum.ACREAGE]: BuildingClassEnum.DETACHED,
  [BuildingTypeEnum.LOW_RISE_APARTMENT]: BuildingTypeEnum.LOW_RISE_APARTMENT,
  [BuildingTypeEnum.HIGH_RISE_APARTMENT]: BuildingTypeEnum.HIGH_RISE_APARTMENT,
  [BuildingTypeEnum.HALF_DUPLEX]: BuildingClassEnum.SEMI_DETACHED,
  [BuildingTypeEnum.DUPLEX]: BuildingClassEnum.SEMI_DETACHED,
  [BuildingTypeEnum.FOURPLEX]: BuildingClassEnum.ROW_TOWNHOUSE,
  [BuildingTypeEnum.TRIPLEX]: BuildingClassEnum.ROW_TOWNHOUSE,
  [BuildingTypeEnum.VACANT_LAND]: BuildingClassEnum.VACANT_LAND,
};
